const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEComerceWebsites(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    style: {
      fill: "#ff3a23"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.86 8.45a.44.44 0 0 0-.37-.19H7.21l-.42-1.21a.37.37 0 0 0-.26-.27l-2.12-.84a.46.46 0 0 0-.57.31.47.47 0 0 0 .23.54L6 7.55l2.36 6.79a.4.4 0 0 0-.23.23l-.69 1.88a.39.39 0 0 0 0 .35.38.38 0 0 0 .36.2h.35a1.34 1.34 0 1 0 2.38.91 1.33 1.33 0 0 0-.35-.91h3a1.38 1.38 0 0 0-.35.91 1.36 1.36 0 1 0 2.72 0 1.33 1.33 0 0 0-.35-.91h.43a.38.38 0 1 0 0-.76H8.34L8.76 15h6.84a.43.43 0 0 0 .43-.31l1.89-5.91a.41.41 0 0 0-.06-.4zm-8.7 10a.61.61 0 0 1 0-1.22.61.61 0 0 1 .61.61.6.6 0 0 1-.6.6zm5 0a.61.61 0 0 1 0-1.22.61.61 0 0 1 .61.61.6.6 0 0 1-.6.6zm2.38-8.29h-2.32v-1h2.65zm-.67 2.08h-1.65V11.1h2zm-4.65 0V11.1h2.09v1.17zm2.09.91v1h-2.09v-1zM8.2 11.1h2.11v1.17H8.6zm3-.91v-1h2.09v1zm-.91-1v1H7.88l-.35-1zm-1.39 4h1.39v1h-1zm5.3 1v-1h1.36l-.31 1z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEComerceWebsites);
export default __webpack_public_path__ + "static/media/E-comerceWebsites.bbc28307ff0501f29a9313ef108aaadf.svg";
export { ForwardRef as ReactComponent };